import React from 'react';
import Parser from 'html-react-parser';
import { Link, linkRenderer } from '@ynap/router';
import { raygun } from '@ynap/clientside-monitoring';

const processEditorialContent = ({ content, urlConfig = {}, internal_urls = [], locale, editorialId, selectedPartNumber }) => {
    if (!content) return content;

    try {
        const shouldCleanContent = ['SIZE_AND_FIT', 'DETAILS_AND_CARE', 'SIZE_CHART'].includes(editorialId);
        const cleanedContent = shouldCleanContent
            ? content
                  .replace(/\r\n/g, ' ')
                  .replace(/-\s/g, '<br>- ')
                  .replace(/&bull /g, '<br>&bull ')
                  // Clean bullet points that already had line break in front of them
                  .replace(/<br><br>- /g, '<br>- ')
                  .replace(/ #/g, '<br><br>#')
                  // Remove line breaks form the begining of the content
                  .replace(/^(\s*<br>\s*)+/g, '')
            : content;

        // This Japanese condition is a tactical solution for this fix: https://jira.nap/browse/TONWEB-2432
        const matchedItems = locale === 'ja-jp' ? cleanedContent.split(/\r\n|<br>|<br\/>|\s\/\s/) : cleanedContent.split(/\r\n|<br>|<br\/>/);
        if (!matchedItems) return cleanedContent;

        let isList = false;

        const transformed = matchedItems.reduce((accumulator, item, index) => {
            if (item.charAt(0) == '#') {
                //Underline
                //removes # and wraps in <div> with underline style
                return accumulator + `<h4 className="underline" >${item.substring(1)}</h4>`;
            } else if (item.substring(0, 2) == '- ' || item.substring(0, 7) == '&bull; ') {
                let trimIndex = item.substring(0, 2) == '- ' ? 2 : 0;
                trimIndex = item.substring(0, 7) == '&bull; ' ? 7 : trimIndex;

                if (item.match(/- |&bull; /g).length > 1) {
                    return accumulator + list(item); //in case format... -point1- point2- point3
                }

                //List Item
                //if first list item add open <ul> tag and <li> tags
                //if subsequent list item add <li> tags
                const listItem = isList ? `<li>${item.substring(trimIndex)}</li>` : `<ul><li>${item.substring(trimIndex)}</li>`;
                isList = true;
                return accumulator + listItem;
            } else if (isList) {
                //if previous item was LAST list item add add close </ul> tag
                isList = false;
                return accumulator + `</ul>${item}`;
            } else if (item.length == 0) {
                //if item is '' (i.e. there was a \r\n\r\n ) then add <br /> tag
                //Ignore if it the final item
                const append = index == matchedItems.length - 1 ? '' : '<br/>';
                return accumulator + append;
            }
            //because \r\n's were removed, wrap in a div
            return accumulator + `<p>${item}</p>`;
        }, '');

        return withLinks(transformed, urlConfig, internal_urls, locale);
    } catch (error) {
        raygun.helpers.agent('send', { error, tags: [editorialId, selectedPartNumber, 'editorial', 'pdp'] });
        return null;
    }
};

//find <a> tags and convert to Link components
//ignore external links
const withLinks = (content, urlConfig, internal_urls, locale) =>
    Parser(content, {
        replace: function myFunc(a) {
            // to remove links and script tags - replace with empty React Fragment
            if (a.name === 'link' || a.name === 'script') return <></>;

            if (a.attribs && a.attribs.href) {
                if (a.attribs.id === 'internal') return <Link to={a.attribs.href}>{a.children[0]?.data}</Link>;
                else {
                    return linkRenderer(urlConfig, internal_urls, locale, a.attribs.href, a.children[0]?.data);
                }
            }
        },
    });

//Some responses return lists like so... - Navy and red cotton-jersey- Crew neck- 100% cotton- Machine wash" i.e. no \r\n's
const list = (content) => {
    if (content.indexOf('- ') == 0 || content.indexOf('&bull; ') == 0) {
        //find dashes and convert to unordered list
        //replace dashes with space with list items
        let replaceDashes = content.replace(/(- |&bull; )/g, '</li><li>');
        //remove first and replace with start of ul
        let openList = replaceDashes.replace('</li>', '<ul>');
        //add final li to end of string
        let closedList = (openList += '</li></ul>');
        return closedList;
    }
    return content;
};

export default processEditorialContent;
